//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from '@/utils/wx'
import { checkSessionStatus } from '@/common/utils/ajax'
export default {
    data () {
        return {
            inited:  false
        }
    },
    computed: {
        is_tabbar_page () {
            const { name } = this.$route
            return ['Home', 'AllBuildings', 'Messages', 'PersonalCenter'].includes(name)
        },
        is_home () {
            const { name } = this.$route
            console.error('name', name)
            return name === 'Home'
        }
    },
    mounted () {
        window.wx = wx
        this.$sendCtmEvtLog('App打开')
        if (this.app_type === 'tft') {
            checkSessionStatus().then(() => {
                this.inited = true
            })
        } else {
            this.inited = true
        }
    },
    methods: {
        hideQr () {
            document.getElementById('mini_qr_dlg').style.display = 'none'
        }
    }
}
